const KST_OFFSET_MS = 9 * 60 * 60 * 1000

export interface CalendarCell {
  day: number
  /** 0=일 … 6=토 */
  weekday: number
  isWedding: boolean
}

/** month는 1부터 센다. */
export function leadingBlanks(year: number, month: number): number {
  return new Date(Date.UTC(year, month - 1, 1)).getUTCDay()
}

export function buildMonthGrid(year: number, month: number, weddingDay: number): CalendarCell[] {
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate()
  const first = leadingBlanks(year, month)
  return Array.from({ length: days }, (_, i) => ({
    day: i + 1,
    weekday: (first + i) % 7,
    isWedding: i + 1 === weddingDay,
  }))
}

/** 시각이 아니라 날짜 경계로 센다. 예식 당일은 몇 시든 D-DAY다. */
export function dDayLabel(targetMs: number, nowMs: number): string {
  const dayOf = (ms: number) => Math.floor((ms + KST_OFFSET_MS) / 86_400_000)
  const diff = dayOf(targetMs) - dayOf(nowMs)
  if (diff > 0) return `D-${diff}`
  if (diff === 0) return 'D-DAY'
  return `D+${-diff}`
}
